<template>
  <div>
    <div id="accordionMeasurement">
      <div class="card-pei">
        <div class="card-header">
          <div class="mb-0">
            <div
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <div class="accordion-header-container">
                <BadgeModal
                  class="badge-modal-custom"
                  i="fas fa-plus orange-icon"
                  title="Añadir Documento"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          id="collapseOne"
          class="collapse show"
          aria-labelledby="headingOne"
          data-parent="#accordionMeasurement"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <CustomDatePicker
                  v-model="info.date"
                  label="Fecha:"
                  :value="info.currentDate"
                />
              </div>
              <div class="col-md-4">
                <CustomDropDown
                  v-model="info.type"
                  label="Tipo:"
                  placeholder="Seleccion"
                  fieldkey="id"
                  fieldname="title"
                  :options="documentTypeList"
                />
              </div>
              <div class="col-md-4 w-100">
                <BoxIconButton
                  title="Presione aquí para anejar documento"
                  icon="fas fa-file-plus"
                  label="Documento:"
                  class="box-icon-button-custom"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col">
                <CustomTextArea
                  v-model="info.comment"
                  :rows="4"
                  label="Añadir Comentario"
                  :maxlength="500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-right mt-4">
      <ActionButton i="fas fa-plus" variant="success m-2" @click="save">
        Añadir
      </ActionButton>
    </div>
  </div>
</template>

<script>
import {
  CustomDatePicker,
  ActionButton,
  CustomDropDown,
  CustomTextArea,
} from '@/components/common';
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import BadgeModal from '@/components/common/page/badge/BadgeModal';

export default {
  name: 'ControversyDocumentAdd',
  data() {
    return {
      info: {
        date: new Date(),
        type: {},
        document: '',
        comment: '',
      },
    };
  },
  props: {
    documentTypeList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    add(item) {
      this.$emit('on-add', item);
    },
    save() {
      this.$emit('on-save', this.info);
    },
  },
  components: {
    ActionButton,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    BoxIconButton,
    BadgeModal,
  },
};
</script>

<style scoped>
.box-icon-button-custom >>> .btn {
  padding: 1px 23px;
  width: 100%;
}

.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}
</style>
